import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {RelationType} from "../models/relation";
import {CargoType} from "../models/cargo";
import {AlertModel} from "../../alerts/models/alert";
import {LocationDropDownEntryModel} from "../../topology/models/location";
import {AvailableSupervisorActions, OrderStatusEnum, SupervisorFlowAction} from "../models/order";
import {HttpErrorModel} from "../../common/models/httpError";

export class TransportationService {
    public static async getNotifications(id: string): Promise<AxiosResponse<PageableModel<AlertModel>>> {
        const url = Api.getUrl(apiUrls.alerts.alertsForOrder);
        const params = `query=tags.orderId::${id}`;

        return await http.get<PageableModel<AlertModel>>(
            `${Api.addParams(url, params)}`
        );
    }

    public static async getAllRelationTypes(): Promise<AxiosResponse<RelationType[]>> {
        return await http.get(Api.getUrl(apiUrls.transportation.relationTypes));
    }

    public static async getAllCargoTypes(): Promise<AxiosResponse<CargoType[]>> {
        return await http.get(Api.getUrl(apiUrls.transportation.cargoTypes));
    }

    public static async getEntryOrExitLocationsForDropDown(): Promise<AxiosResponse<LocationDropDownEntryModel[]>> {
        return await http.get(`${Api.getUrl(apiUrls.topology.entryOrExit)}/dropdown`);
    }

    public static async getEntryOrExitAndNoAutomationLocationsForDropDown(): Promise<AxiosResponse<LocationDropDownEntryModel[]>> {
        return await http.get(`${Api.getUrl(apiUrls.topology.entryOrExit)}-no-automation/dropdown`);
    }

    public static async getParkingLocationsForDropDown(): Promise<AxiosResponse<LocationDropDownEntryModel[]>> {
        return await http.get(`${Api.getUrl(apiUrls.topology.locations)}/parking-dropdown`);
    }

    public static async getAllStatusesForRelationType(relationType: RelationType): Promise<AxiosResponse<OrderStatusEnum[]>> {
        return await http.get(`${Api.getUrl(apiUrls.transportation.statusForRelationType)}/${relationType}`);
    }

    public static async getAvailableActions(orderId: string): Promise<AxiosResponse<AvailableSupervisorActions>> {
        return await http.get(`${Api.getUrl(apiUrls.transportation.transportation)}/${orderId}/supervisor-actions`);
    }

    public static async executeSupervisorAction(orderId: string, supervisorFlowAction: SupervisorFlowAction) : Promise<AxiosResponse<HttpErrorModel[] | any>> {
        const action = {action: supervisorFlowAction};
        return await http.post(`${Api.getUrl(apiUrls.transportation.transportation)}/${orderId}/execute-supervisor-action`, action);
    }
}
